import React, { useRef, useEffect } from 'react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';

const MayarAlert = ({ message, isError, isSuccess = false, ...props }) => {
  // TODO: write better message based on the graphql response
  const alertRef = useRef(null);

  useEffect(() => {
    if (message && isError && alertRef.current) {
      alertRef.current.focus();
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [message]);
  return (
    <>
      {isError && (
        <Alert 
        innerRef={alertRef}
        tabIndex={-1}
        color="danger" {...props}>
          {message || 'Error! Silahkan coba lagi atau hubungi CS'}
        </Alert>
      )}
      {isSuccess && (
        <Alert color="success" {...props}>
          {message || 'Berhasil memperbarui data'}
        </Alert>
      )}
    </>
  );
};

MayarAlert.propTypes = {
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  message: PropTypes.string
};

export default MayarAlert;
